<template>
  <router-link :to="link" class="dashbaord-link"><v-icon v-if="icon" left>{{ icon }}</v-icon>{{ texte }}</router-link>
</template>

<script>
export default {
  name: "DashLink",
  props : ['link' , 'icon' , 'texte']
}
</script>

<style scoped>

</style>